import { Component, ViewChild, AfterViewInit, ElementRef, Output, EventEmitter, Input } from '@angular/core';
import { MediaService } from '../peers/media.service';
import { SessionManagerService } from '../services/session/session-manager.service';
import { WsService2 } from '../services/ws/ws.service';
import { WbService } from '../wb.service';
import { Modal } from 'ng2-modal';
import { Headers, RequestOptions, Response, Http } from '@angular/http';
import 'rxjs/add/operator/catch';
import { environment } from '../../../environments/environment';
import { HttpRequest } from 'selenium-webdriver/http';
declare var $;
declare var XMLHttpRequest;
declare var window
@Component({
  selector: "dskl-tools-materials",
  templateUrl: 'materials.component.html',

})

export class MaterialsComponent {

  @Input() pageId;
  @ViewChild("materialsModal") materialsModal: Modal;
  @ViewChild("materialsModalDemo") materialsModalDemo: Modal;
  @ViewChild("notSupportedFileFormat") notSupportedFileFormat: Modal;
 @ViewChild("optimizationNew") optimizationNew: Modal;
  @ViewChild("optimizationInProgress") optimizationInProgress: Modal;

  @ViewChild("uploadError") uploadError: Modal;
  materials = [];
  teacherWbHash = "";
  showBack = false;
  constructor(public sessionManager:SessionManagerService, private mediaService: MediaService, private wsService: WsService2, private wbService: WbService, private http: Http) { }
  open() {
    if (this.wbService.isDemo()) {
      this.materialsModalDemo.open();
      return;
    }
    this.showBack = false;
    //teacher/content/{teacherAccountHash}/getWbHash
    var url = environment.wbBackendUrl + "api/get/" + this.wsService.getMe() + "/contentHash";
    var self = this;
   
    $.ajax({
      url: url,
      method: "POST",
      success: function (data) {
        if (data && data.object && data.status){
        self.teacherWbHash = data.object;
        self.wbService.setTeacherWbHash(self.teacherWbHash);
        console.log(data, self.teacherWbHash)
        self.materialsModal.open();
        //console.log(self.currentFile);
       // if (!self.sessionManager.currentFile) {
          self.getMaterials(0);
       // } else {
       //   self.materials = [];
       // }
        self.mobileClassroomId = self.getMobileClassroomId(0);
        }else{
            window.alert("Could not get content hash, please, contact the support");
        }
      },
      error: function (error) {
        alert("Could not connect to server, please, try again or contact the support");
      }
    })



  }
  private getMobileClassroomId(id) {
    return this.wsService.userHash.substr(0, 4) + "-" + id;
  }
  current = null;
  onBack() {
    this.sessionManager.currentFile = null;
    if (!this.current.folder) {
      this.getMaterials(0);
    } else {
      this.getMaterials(this.current.folder.parentFolder);

    }

    console.log("current is ", this.current)
  }
  currentPage = 0;
  onMaterialClicked(m) {
    console.log("clicked material: ", m)

    this.current = m.content;
    m = m.content
    if (m.discriminator != 'FileContent' && m.discriminator != 'FolderContent') {
      //  this.materialsModalDemo.close();
      this.notSupportedFileFormat.open();
      return;
    }
    if (m.optimizationType=='NEW'){
       this.optimizationNew.open();
      return;
    }
    if (m.optimizationType=='IN_PROGRESS'){
       this.optimizationInProgress.open();
      return;
    }
    if (m.discriminator == 'FileContent') {

      //this.currentFile = m;
      this.sessionManager.currentFile = m;
      this.sessionManager.openFile(m, 0);
    } else {
    
       
      this.mobileClassroomId = this.getMobileClassroomId(m.id);
      this.getMaterials(m.id);
    }
  }
  _loagPage(file, next) {
    this.sessionManager.openFile(file, file.page + (next ? 1 : -1));
  }
  nextPage() {
    this.sessionManager.nextPage();//_loagPage(this.currentFile, true);
  }
  prevPage() {
    this.sessionManager.prevPage();//_loagPage(this.currentFile, false);
  }
  fileUploads = false;
  //currentFile = null;

  /*private openFile(file, page) {

    console.log(file, page)
    this.currentPage = page;

    file.page = page;
    this.wbService.showFile(file);
  }
*/
  
  fileToUpload;
  onChange(fileInput: any) {
    this.fileToUpload = fileInput.target.files[0];
  }
  checkFileUpload = false;
  sendFile(description) {
    this.checkFileUpload = true;
    var id = 0;
    if (this.current.folder) {
      id = this.current.folder.id;
    }
    if (description == "" || !this.fileToUpload) return;
    this.postFile(id, description, this.fileToUpload)
  }
  fileSent(o) {
    if (o.object)
      this.sessionManager.openFile(o.object.id, 0);
    else {
      window.alert(o.description)
    }
  }

  optimize(file) {
    console.log(file)
    ///upload/{contentId}/{fileContentUuid}
    $.ajax({
      url: environment.contentsBackendUrl + this.teacherWbHash + '/upload/' + file.id + '/' + file.nameUuid,
      method: "POST",
      success: (data) => {
        this.getMaterials(this.lastDirId)
        alert('файл ' + file.name + ' e готов за ползване')
      }
    })  
  }
  progress
  fileProcessing
  postFile(directoryId, description, file) {
    console.log("will upload file in + dir:" + directoryId)
    if (directoryId == null) {
      directoryId = 0;
    }

    let urlToSend = environment.contentsBackendUrl + this.teacherWbHash + "/file/upload/";
    var data = new FormData();
    data.append("file", file);
    data.append("dto", new Blob([JSON.stringify({ isPreview: false, name: description, description: "", accessType: "SHARED", parentFolderId: this.lastDirId })], { type: "application/json" }));
    let self = this;
    
    $.ajax({
      url: urlToSend,
      data: data,
      cache: false,
      contentType: false,
      processData: false,
      type: 'POST',
      xhr: function(){
        var xhr = new window.XMLHttpRequest();
          // Handle progress
          //Upload progress
        xhr.upload.addEventListener("progress", function(evt){
         
            if (evt.lengthComputable) {
               var percentComplete = evt.loaded / evt.total;
               //Do something with upload progress
               console.log(percentComplete);
               self.progress = (percentComplete*100).toFixed(0);
               if (self.progress>99){
                 self.fileProcessing = true;
               }
            }
        }, false);
        
 
        return xhr;
     },
      error: function (e) {
        self.progress = 0;
        self.uploadError.open();
        self.fileProcessing = false;
      },
      success: function (e) {
        console.log("File sent")
        if (self.current.folder)
          self.getMaterials(self.current.folder.id)
        else
          self.getMaterials(0)
        //self.fileSent(e);
        self.fileProcessing = false;
        self.progress = 0;
      }
    });
  }
  lastDirId = 0;
  mobileClassroomId;
  mainFolderId;
  fileSendError(){

  }
  public getMaterials(id, cb=null) {
    var url;
    if (id > 0) {
      url = environment.contentsBackendUrl + this.teacherWbHash + "/list/" + id;
    } else {
      url = environment.contentsBackendUrl + this.teacherWbHash + "/list";
    }

    var type;
    var self = this;
    this.http.post(url, {})
      .subscribe(data => {
        var materials = data.json();
        this.lastDirId = materials.parentContent.content.id
        this.current = materials;
        console.log("got folder: ", this.current)
         this.showBack=!this.current.topFolder
        this.materials = materials.contents;
        console.log(this.materials.length)
        console.log("got materials", this.materials);
        if (cb){
          cb();
        }
        /*for (var f of materials.contents) {
          f["file"]=true;
          this.materials.push(f);  
        }*/
      })
  }

  post(url, body) {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers, withCredentials: true });
    return this.http.post(environment.contentsBackendUrl + url, body, options)
      .map(this.extractData)
    // .catch(this.handleError);

    // return Observable.of(true).delay(1000).do(val => this.isLoggedIn = true);
  }
  private extractData(res: Response) {
    let body = res.json();
    console.log(body)
    if (body.status === false) {
      console.log(body.object.description)
      alert(body.object.description);
      return false;
    }
    return body.object || {};
  }
  private handleError(error: any, a: any) {

    //let errMsg = (error.message) ? error.message :
    // error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    console.error(error); // log to console instead
    //this.translate.get("ERROR_COMMON").subscribe((res: string) => {
    alert("Настъпи грешка. Опитай пак");
    //});
  }
}


// WEBPACK FOOTER //
// /app/src/app/wb/tools/materials.component.ts